import React from "react";
import * as Sentry from "@sentry/react";

import classNames from "classnames";

type Size = "small" | "medium" | "large" | "x-large" | "2x-large";

interface InitialsIconProps {
  initials: string;
  className?: string;
  size?: Size;
  invert?: boolean;
}

const InitialsIcon = ({
  initials,
  className,
  size = "small",
  invert = false,
}: InitialsIconProps) => {
  if (typeof initials !== "string") {
    Sentry.captureMessage(`Initials are not a string ${typeof initials}`, {
      level: "error",
    });
  }

  // Guard against initials being a non-string value at runtime
  const validInitials = typeof initials === "string" ? initials : "U";

  return (
    <div className={classNames(styles.container(size, invert), className)}>
      {validInitials.toUpperCase()}
    </div>
  );
};

const styles = {
  container: (size: Size, invert: boolean) =>
    classNames(
      "tw-flex",
      "tw-items-center",
      "tw-justify-center",
      "tw-rounded-full",
      "tw-font-semibold",
      "tw-transition-colors",
      invert
        ? "tw-bg-fay-500 tw-text-fay-100"
        : "tw-bg-fay-100 tw-text-fay-500",
      "group-hover:tw-bg-fay-500 group-hover:tw-text-fay-100",
      {
        small: "tw-text-xs",
        medium: "tw-text-xs",
        large: "tw-text-xs",
        "x-large": "tw-text-4xl",
        "2x-large": "tw-text-6xl",
      }[size],
      {
        small: "tw-h-6 tw-w-6",
        medium: "tw-h-8 tw-w-8",
        large: "tw-h-10 tw-w-10",
        "x-large": "tw-h-32 tw-w-32",
        "2x-large": "tw-h-40 tw-w-40",
      }[size],
    ),
};

export default InitialsIcon;
